import { render, staticRenderFns } from "./Wp_all_search_page.vue?vue&type=template&id=62b9a1ae&scoped=true&"
import script from "./Wp_all_search_page.vue?vue&type=script&lang=js&"
export * from "./Wp_all_search_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b9a1ae",
  null
  
)

export default component.exports